import { createReducer } from "./functions";

import { KPIS_SET_LIST, KPIS_SET_MATCH_FILTERS } from '../types';

const initialState = {
  kpisList: [],
  page: 0,
  pages: 0,
  pageSize: 20,
  match: {}
}

const setKpisList = {
  [KPIS_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page")
    ? action.payload.page
    : state.page;
    const pages = action.payload.hasOwnProperty("pages")
      ? action.payload.pages
      : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages)
      hasNext = false;
    return { ...state, kpisList: action.payload.docs, page, pages, hasNext };
  }
}
const setKpisMatch = {
  [KPIS_SET_MATCH_FILTERS]: (state, action) => {
    return {...state, match: action.payload}
  }
}
const kpisReducer = createReducer(initialState, {
  ...setKpisList,
  ...setKpisMatch
})

export default kpisReducer; 


// WEBPACK FOOTER //
// src/redux/reducers/kpisReducer.js